export default __webpack_public_path__ + "static/media/ele_example_4_2.fdea0f56.png";